// 手机号
export const phoneReg = /^[1][3-9]\d{9}$|([6|9])\d{7}$|[0][9]\d{8}$|6\d{5}$/;
// 固定电话
export const telephoneReg = /^((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/;
